import { Container, FooterContainer, IntroContainer, MainContainer } from "./ComponentCss";

import btn_check_icon from "../_assets/images/btn_check_icon.png";
import logo_footer from "../_assets/images/logo_footer.png";
import { GrNext } from "react-icons/gr";
import { Link } from "react-router-dom";

const FooterComponent = ({status, setSpyEle}) => {

    return (
        <MainContainer style={{ background: "#000", color: "#fff" }}>
            <IntroContainer className="footer">
                <div className="intro-tit">
                    <h1>유니세프 응답하기 캠페인</h1>
                </div>
                <div className="intro-img-cont">
                    <div className="intro-img1">
                        <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/intro_img1.b80bcceb58fce390b776.png" } alt="하마르 이미지" className="pc" />
                        <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/intro_img1_m.e192f787fc8361d8ed2e.png" } alt="하마르 이미지" className="mo" />
                        <p>
                            우리나라 11살 남자아이가<br/>
                            연필을 들고 공부하는 것이 당연할 때,<br/>
                            <span>그곳의 아이는 총을 든 <br className="mo" />소년병이 되는 것이 당연하고</span>
                        </p>
                    </div>
                    <div className="intro-img2">
                        <p>
                        우리나라 11살 여자아이가 <br className="mo" />아빠에게<br className="pc"/>
                        생일 축하 선물을 받는 것이 당연할 때,<br/>
                        <span>그곳의 아이는 아빠의 강요로 <br className="mo" />조혼하는 것이 당연한 현실</span>
                        </p>
                        <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/intro_img2.9c77c14663461f75e861.png" } alt="밀락 이미지" className="pc" />
                        <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/intro_img2_m.f6bbfd529451b7868326.png" } alt="밀락 이미지" className="mo" />
                    </div>
                </div>
            </IntroContainer>
            <Container className="footer-1">
                <div className="comm">
                    <p>
                        전쟁터에 홀로 남은 아이들에게<br />
                        악습에 학대당하는 소녀들에게
                    </p>
                    <p>
                        지금, <span>당신의 후원</span>이<br />
                        <span>그 무엇보다 절실</span>합니다
                    </p>
                    <button onClick={ () => window.open('https://www.unicef.or.kr/donate/?supportTerm=FM01&supportCategory=D001&solicitcode=DR22E') } alt="후원으로 응답하기">
                        <div>
                            <img src={ btn_check_icon } alt="체크 아이콘" style={{ width: "1.5rem", marginRight: "0.5rem" }} />
                            후원으로 응답하기
                        </div>
                        <GrNext className="btn-img" />
                    </button>
                </div>               
                <span className="copyright">©UNICEF/ UNI141744</span>
            </Container>
            <Container className="footer-2">
                <div className="comm">
                    <p className="comm-2">
                        더 이상 이런 일들이 당연하지 않도록,<br />
                        유니세프가 어린이들에게 <br className="mo" />무엇이 옳은 답인지 알려주려고 합니다.
                    </p>
                    <p className="comm-3">
                        어린이다운 삶을, 더 큰 꿈을 꿀 수 있는 기회를<br />
                        그리고 그것이 당연한 세상을 위해
                    </p>
                    <p>
                        당신의 응답이 필요합니다<br />
                        지금, <span>유니세프</span>로 답해주세요
                    </p>
                    <button onClick={ () => window.open('https://www.unicef.or.kr/donate/?supportTerm=FM01&supportCategory=D001&solicitcode=DR22E') } alt="후원으로 응답하기">
                        <div>
                            <img src={ btn_check_icon } alt="체크 아이콘" style={{ width: "1.5rem", marginRight: "0.5rem" }} />
                            후원으로 응답하기
                        </div>
                        <GrNext className="btn-img" />
                    </button>
                    <Link to={ window.location.search.indexOf("qna") < 0 ? window.location.search.indexOf("war") > -1 ? "?step=earlymarriage" : "?step=war" : "/"} className="another-asmr">
                        { window.location.search.indexOf("qna") > -1 ? 'ASMR 체험하기' : '다른 ASMR 들어보기' }
                        <GrNext className="btn-img" style={ window.location.pathname === "?step=qa" ? { marginLeft: "4rem" } : { marginLeft: "0" } } />
                    </Link>
                </div>
                <span className="copyright">©UNICEF/ UN0308055</span>
            </Container>
            <FooterContainer>
                <img src={ logo_footer } alt="유니세프 로고" style={{ width: "18.8rem", marginBottom: "2.5rem" }} />
                <div className="footer-comm">
                    단체명 : 사단법인 유니세프한국위원회 (고유번호:102-82-07606) | 연락처 : 02-737-1004 <span className="footer-pc">|</span><br className="mo" /> 주소 : [04099] 서울시 마포구 서강로 60(창전동) | 대표자 : 정갑영<br />
                    <span style={{ color: "#686868" }}>COPYRIGHT ⓒ THE KOREAN COMMITTEE FOR UNICEF. ALL RIGHT RESERVED</span>
                </div>
            </FooterContainer>
        </MainContainer>
    );
};

export default FooterComponent;